import { useCallback, useEffect, useRef, useState } from 'react';

import { listServices } from '../../services/api/services.api';
import type { Service } from '../../services/types/service.types';

export function useTenantServices(tenantId: number | undefined) {
  const [services, setServices] = useState<Service[]>([]);
  const [loading, setLoading] = useState(Boolean(tenantId));
  const [error, setError] = useState<string | null>(null);
  const mountedRef = useRef(true);
  const requestGenerationRef = useRef(0);

  const loadServices = useCallback(() => {
    const generation = ++requestGenerationRef.current;
    const isCurrentRequest = () =>
      mountedRef.current && requestGenerationRef.current === generation;

    if (tenantId === undefined) {
      setServices([]);
      setLoading(false);
      setError(null);
      return Promise.resolve();
    }

    setLoading(true);
    setError(null);

    return listServices(tenantId)
      .then((data) => {
        if (isCurrentRequest()) setServices(data);
      })
      .catch(() => {
        if (isCurrentRequest()) setError('خطا در دریافت سرویس‌های این تننت');
      })
      .finally(() => {
        if (isCurrentRequest()) setLoading(false);
      });
  }, [tenantId]);

  useEffect(() => {
    mountedRef.current = true;
    void loadServices();
    return () => {
      mountedRef.current = false;
    };
  }, [loadServices]);

  return { services, loading, error, refetch: loadServices };
}
